<template>
  <InfoModal
    v-model="modelValue"
    :title="i18n.global.t('pages.dashboard.driversWithPotentiallyExcessiveHours.title')"
    modalHeight="80%"
    slotTextAreaHeight="60%"
  >
    <template v-slot:text>
      <div class="h-100">
        <div class='d-flex justify-content-end'>
          <small class="p-3 fw-bold">
            {{ `${month} ${i18n.global.t('pages.dashboard.monthly')} (${start_date} ~ ${end_date}) ${i18n.global.t('pages.dashboard.displayData')}` }}
          </small>
        </div>
        <div
          class="row mx-1 dashbord-list"
          style="height: 95%"
        >
          <v-table
            class="h-100 px-0"
          >
            <thead>
              <tr>
                <th>
                  {{ i18n.global.t('pages.dashboard.driverName') }}
                </th>
                <th>
                  {{ i18n.global.t('pages.dashboard.driverId') }}
                </th>
                <th>
                  {{ i18n.global.t('pages.dashboard.driversWithPotentiallyExcessiveHours.restraint') }}
                </th>
                <th>
                  {{ i18n.global.t('pages.dashboard.driversWithPotentiallyExcessiveHours.predictionRestraintTime') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-if="details?.length">
                <tr
                  v-for="item in details"
                  :key="item.driver_id"
                  :style="'background-color:' + item?.restraint_over_threshold_background_color "
                  :class="item?.restraint_over_threshold_background_color ? 'overThresholdRow' : ''"
                >
                  <td>
                    {{ item.last_name }} {{ item.first_name }}
                  </td>
                  <td>
                    {{ item.driver_id }}
                  </td>
                  <td>
                    {{ convertSecondsToHHmm(item.restraint) }}
                  </td>
                  <td :style="`color: ${item?.prediction_restraint_color}`">
                    {{ convertSecondsToHHmm(item.prediction_restraint_time) }}
                  </td>
                </tr>
              </template>
            </tbody>
          </v-table>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex justify-content-end m-3">
        <v-btn class="m-1 reset-btn" @click="modelValue = false">
          {{ i18n.global.t('common.closeBtn') }}
        </v-btn>
      </div>
    </template>
  </InfoModal>
</template>

<script setup lang="ts">
import 'gitart-vue-dialog/dist/style.css'
import InfoModal from "@/components/Common/InfoModal.vue"
import { computed } from 'vue'
import i18n from '@/lang/i18n';

const emits = defineEmits(['update:modelValue'])
const props = defineProps<{
  modelValue: boolean,
  start_date: string,
  end_date: string,
  details: any[],
}>()

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

const month = computed(() => {
  return new Date(props.end_date).getMonth() + 1
})

const convertSecondsToHHmm = computed(() => (seconds: number) => {
  let hour = Math.floor(seconds / 3600);
  let minutes: string | number = Math.floor(seconds % 3600 / 60);
  if (minutes < 10) minutes = '0' + minutes;

  return (hour + ':' + minutes);
})
</script>

<style>
.dashbord-list {
  position: relative;
}
.dashbord-list .v-table__wrapper {
  overflow: auto !important;
  max-height: 95%;
}
.dashbord-list .v-table__wrapper::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.dashbord-list .v-table__wrapper::-webkit-scrollbar-thumb {
  background-color: rgb(150,150,150);
  border-radius: 5px;
  box-shadow: inset 3px 3px 3px rgba(255,255,255,0.2);
}
.dashbord-list .v-table__wrapper::-webkit-scrollbar-track {
  background-color: rgb(220,220,220);
  border-radius: 5px;
  box-shadow: inset 3px -3px 5px rgba(0,0,0,0.2);
}
.dashbord-list table th {
  background-color: #f8f9fa;
  position: sticky;
  top: 0;
}
.dashbord-list table .fix-td {
  background-color: white;
  position: sticky;
  left: 0;
}
.overThresholdRow>td{
  font-weight: bold;
}
</style>
